import { OperationLogRequestPayload } from "@/data/payload/super-admin/operation-log-request-payload";
import { OperationLogInfoEntity } from "@/domain/entity/super-admin/operation-log-info-entity";
import { SuperAdminRepository } from "@/domain/repository/super-admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchOperationLogUsecase {
  constructor(private readonly operationLogRepository: SuperAdminRepository) {}

  async execute(
    pageSize: number,
    currentPage: number,
    selectTab: string,
    searchId?: string
  ): Promise<SATResult<OperationLogInfoEntity, SATError>> {
    const newPayload: OperationLogRequestPayload = {
      pageSize: pageSize,
      currentPage: currentPage,
      selectTab: selectTab,
      searchId: searchId,
    };
    const result = await this.operationLogRepository.getOperationLog(newPayload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(result.value);
  }
}
